import ButtonBase from '@/components/ButtonBase';
import styled from '@emotion/styled';
import { FormattedMessage } from 'react-intl';
import { type Moment } from 'moment';
import { type HTMLButtonProps } from '@/lib/types';
import isTouchDevice from '@/lib/utils/isTouchDevice';

type OpenButtonProps = Omit<HTMLButtonProps, 'children'> & {
  displayedDate: Moment;
};

const StyledOpenButton = styled(ButtonBase)({
  marginTop: -8,
  height: 32,
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  ':disabled': {
    cursor: 'not-allowed',
  },
});

const OpenButton = ({ displayedDate, ...props }: OpenButtonProps) => {
  const displayedDateIsEmpty = !displayedDate.isValid();

  return (
    <StyledOpenButton {...props}>
      {displayedDateIsEmpty ? (
        <FormattedMessage
          id={`portfolio.challenge.date_field.button.${
            isTouchDevice() ? 'tap' : 'click'
          }`}
        />
      ) : (
        displayedDate.format('L')
      )}
    </StyledOpenButton>
  );
};

export default OpenButton;
